/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q9Inputs */

const en_pc_faq_q9 = /** @type {(inputs: Pc_Faq_Q9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use PdfCraft for commercial work?`)
};

const zh_pc_faq_q9 = /** @type {(inputs: Pc_Faq_Q9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 可以用于商业用途吗？`)
};

/**
* | output |
* | --- |
* | "Can I use PdfCraft for commercial work?" |
*
* @param {Pc_Faq_Q9Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q9 = /** @type {((inputs?: Pc_Faq_Q9Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q9Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q9(inputs)
	return zh_pc_faq_q9(inputs)
});
export { pc_faq_q9 as "pc.faq.q9" }